import { __spreadArray, __assign } from 'tslib';
import { folderTreeSelector, searchFoldersSelector } from '@keepeek/commons';
import { selectorFamily } from 'recoil';
import { mosaicPreloadingFolderIds } from './atoms.js';

var mosaicFolderTreesSelector = selectorFamily({
    key: "MosaicFolderTreesSelector",
    get: function (_a) {
        var folderIds = _a.folderIds;
        return function (_a) {
            var get = _a.get;
            // Get mosaic folders from preloaded folders
            var folderTrees = folderIds
                .map(function (folderId) { return get(folderTreeSelector(folderId)); })
                .flatMap(function (f) { return (f ? [f] : []); });
            var folderIdsPreloading = get(mosaicPreloadingFolderIds);
            var folderIdsPreloaded = __spreadArray(__spreadArray([], folderIdsPreloading, true), folderTrees.map(function (f) { return f.folder.id; }), true);
            var folderIdsMissing = folderIds.filter(function (f) { return !folderIdsPreloaded.includes(f); });
            // All folders are preload, return them
            if (folderIdsMissing.length === 0) {
                return folderTrees;
            }
            var missingFolderTrees = get(searchFoldersSelector({
                folderIds: folderIdsMissing,
                countMedias: true,
                withChildrenList: false
            }));
            // Build ordered folders
            return folderIds
                .map(function (fId) {
                var folder = folderTrees.find(function (f) { return fId === f.folder.id; });
                if (folder) {
                    return folder;
                }
                return (missingFolderTrees &&
                    missingFolderTrees.find(function (f) { return fId === f.folder.id && f.folder.treeMediaCount && f.folder.treeMediaCount > 0; }));
            })
                .flatMap(function (f) { return (f ? [f] : []); });
        };
    },
    set: function () {
        return function (_a, newValue) {
            var set = _a.set;
            var folderTrees = newValue;
            folderTrees.forEach(function (folderTree) {
                return set(folderTreeSelector(folderTree.folder.id), folderTree);
            });
        };
    }
});
var mosaicElementsSelector = selectorFamily({
    key: "mosaicElementsSelector",
    get: function (_a) {
        var folderIds = _a.folderIds, countMedias = _a.countMedias;
        return function (_a) {
            var get = _a.get;
            var folderTrees = get(mosaicFolderTreesSelector({ folderIds: folderIds }));
            return folderTrees.map(function (ft) {
                return (__assign(__assign({}, ft.folder), { showSubTitle: countMedias, partialLoading: false }));
            });
        };
    }
});

export { mosaicElementsSelector, mosaicFolderTreesSelector };
//# sourceMappingURL=selectors.js.map
